<template>
  <v-hover>
    <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto">
      <div class="c-msg-json">
        <div class="flex-col c-tile">
          <div class="flex-col c-tile-icon">
            <v-icon color="black" :size="26">phone</v-icon>
          </div>
          <div class="c-time">{{ talkTime }}</div>
        </div>
      </div>
    </v-card>
  </v-hover>
</template>

<script>
import CacheUtils from '../../utils/CacheUtils';
import CommunityTalkApi from '../../api/communityTalk';

export default {
  props: {
    tid: { type: Number, required: true },
    /*
      export interface TalkMsgForEvent {
        t: TALK_MSG_TYPE.POST;
        eid: number;
      }
    */
    data: { type: Object, required: true },
    maxWidth: { type: Number, required: true },
    talkMsg: { type: Object, required: true },
  },
  data() {
    const w = Math.min(this.maxWidth / 2, 80);
    return {
      event: null,
      serverRequested: false,
      // {start:number, end:number}
      phoneState: null,
      interval: null,
      intervalServer: null,
    };
  },
  created() {},
  mounted() {
    this.setPhoneState();
  },
  beforeDestroy() {
    this.stopInterval();
  },
  watch: {
    isActive(n, o) {
      if (n && !o) {
        this.startInterval();
        return;
      }
      if (!n && o) {
        this.stopInterval();
        return;
      }
    },
  },
  computed: {
    cacheKey() {
      return `${this.tid}_${this.talkMsg.num}`;
    },
    isSelfMsg() {
      return this.isSelf(this.talkMsg.cmid);
    },
    isActive() {
      if (!this.phoneState || this.phoneState.end) return false;
      if (this.phoneState.start) return this.talkMsg.tstamp > this.unix() - 60 * 60;
      return this.talkMsg.tstamp > this.unix() - 60 * 5;
    },
    talkTime() {
      const ps = this.phoneState;
      if (!ps) return '--:--';
      if (!ps.start) {
        return this.isActive ? $T('talk.calling') : this.isSelfMsg ? $T('button.cancel') : $T('talk.no-accept');
      }
      const sec = ps.end ? ps.end - ps.start : this.unix() - ps.start;
      return this.secToMin(sec);
    },
  },
  methods: {
    startInterval() {
      this.interval = setInterval(async () => {
        this.setPhoneState();
      }, 1000);

      this.intervalCheckServer = setInterval(async () => {
        if (!this.isActive) return;
        const msgs = await CommunityTalkApi.getMsg(this.tid, this.talkMsg.num);
        await this.saveTalkOptionMsgs(msgs);
      }, 15000);
    },
    async saveTalkOptionMsgs(msgs) {
      const m = (await CacheUtils.getTalkOptionMsgs(this.cacheKey)) || {};
      for (const msg of msgs) if (msg.idx) m[`${msg.cmid}_${msg.idx}`] = JSON.parse(msg.msg);
      await CacheUtils.setTalkOptionMsgs(this.cacheKey, m);
    },
    stopInterval() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      if (this.intervalCheckServer) {
        clearInterval(this.intervalCheckServer);
        this.intervalCheckServer = null;
      }
    },
    async setPhoneState() {
      this.phoneState = await this.getPhoneState();
    },
    async getPhoneState() {
      const csMap = (await CacheUtils.getTalkOptionMsgs(this.cacheKey)) || {};
      const statuses = [];
      for (const key of Object.keys(csMap)) statuses.push(csMap[key]);
      const phoneState = this.calcPhoneState(statuses);
      return phoneState;
    },
    calcPhoneState(statuses) {
      if (!statuses) return { start: 0, end: 0 };
      let start = 0;
      let end = 0;
      for (const status of statuses) {
        if (status.type == 'ACCEPTED') {
          start = status.v.t;
          if (end) break;
          continue;
        }
        if (status.type == 'CLOSED') {
          end = status.v.t;
          if (start) break;
          continue;
        }
      }
      return { start, end };
    },
    secToMin(sec) {
      if (sec < 0) return `00:00`;
      const m = this.moment();
      m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      m.add(Math.floor(sec), 'seconds');
      if (sec < 3600) return m.format('m:ss');
      if (sec < 86400) return m.format('H:mm:ss');
      return `${Math.floor(sec / 86400)}d ${m.format('H:mm:ss')}`;
    },
  },
};
</script>

<style scoped>
.c-click {
  cursor: pointer;
  cursor: hand;
}
.c-tile {
  padding-top: 5px;
  padding-bottom: 5px;
}
.c-tile-icon {
  width: 30px;
  height: 30px;
  margin-right: 5px;
}
.c-tile-title {
  font-size: 14px;
  font-weight: 600;
}
.c-title-none {
  color: rgba(0, 0, 0, 0.37);
}
.c-time {
  font-size: 11px;
  width: 75px;
  text-align: center;
}
</style>
